import React from 'react';
import { MapPin, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

const pages = [
  { url: '/', title: 'Home' }
];

export default function Sitemap() {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Header />
      <section id="sitemap" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center mb-8">
            <Link to="/" className="flex items-center text-blue-600 hover:text-blue-800 mr-4">
              <ArrowLeft className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
          </div>
          <h2 className="text-4xl font-bold text-gray-800 mb-8">Sitemap</h2>
          <div className="bg-white rounded-lg shadow-lg p-8">
            <ul className="space-y-6">
              {pages.map((page, index) => (
                <li key={index} className="group">
                  <Link 
                    to={page.url} 
                    className="flex items-start space-x-4 text-gray-700 hover:text-blue-600 transition-colors duration-200"
                  >
                    <MapPin className="w-5 h-5 mt-1 text-blue-600 group-hover:text-blue-800" />
                    <div>
                      <span className="text-lg font-medium block">{page.title}</span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}